import type { SocialLoginConfig } from '#types/config/components/form/socialLogin'

export default {
  providerAuthUrls: {
    facebook: 'https://www.facebook.com/v18.0/dialog/oauth',
    google: 'https://accounts.google.com/o/oauth2/v2/auth',
    amazon: 'https://www.amazon.com/ap/oa'
  }
} satisfies SocialLoginConfig
